/**
 * Generated runtime TestId mirror for frontend/src/features/inbound-connectors/components/ScriptInboundConfigCard.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

import type { TestIdPrefix } from "./types.ts";

export const ScriptInboundConfigCardTestIds = {
  btnCreateScriptConfig: "btn-create-script-config",
  btnEditScriptConfig: "btn-edit-script-config",
  btnValidateScript: "btn-validate-script",
  cardTitleScriptInboundConfig: "card-title-script-inbound-config",
  cardTitleScriptInboundConfigError: "card-title-script-inbound-config-error",
  cardTitleScriptInboundConfigLoading: "card-title-script-inbound-config-loading",
  inputScriptApiKeyHeader: "input-script-api-key-header",
  inputScriptApiKeySecretRef: "input-script-api-key-secret-ref",
  inputScriptBaseUrl: "input-script-base-url",
  inputScriptClientSecretRef: "input-script-client-secret-ref",
  inputScriptConnectTimeout: "input-script-connect-timeout",
  inputScriptPasswordSecretRef: "input-script-password-secret-ref",
  inputScriptReadTimeout: "input-script-read-timeout",
  inputScriptTokenSecretRef: "input-script-token-secret-ref",
  scriptInboundConfigCard: "script-inbound-config-card",
  scriptInboundConfigCardError: "script-inbound-config-card-error",
  scriptInboundConfigCardLoading: "script-inbound-config-card-loading",
  selectScriptAuthType: "select-script-auth-type",
  badgeOp: (key_toLowerCase: string) => `badge-op-${key_toLowerCase}`,
  badgeOpPrefix: () => "badge-op-" as TestIdPrefix,
  badgeOpDisplay: (key_toLowerCase: string) => `badge-op-display-${key_toLowerCase}`,
  badgeOpDisplayPrefix: () => "badge-op-display-" as TestIdPrefix,
  switchOp: (key_toLowerCase: string) => `switch-op-${key_toLowerCase}`,
  switchOpPrefix: () => "switch-op-" as TestIdPrefix
} as const;
